// Tads.ts
class Tads {
  private static _instance: Tads
  private adController: any = null
  private widgetId: string = '548'

  private constructor() {}

  public static getInstance(): Tads {
    if (!Tads._instance) {
      Tads._instance = new Tads()
    }
    return Tads._instance
  }

  public init(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const tryInit = () => {
        if (typeof window !== 'undefined' && (window as any).tads && (window as any).tads.init) {
          this.adController = (window as any).tads.init({
            widgetId: this.widgetId,
            debug: false,
            onShowReward: (adId: any) => {
              console.log('Show ad:', adId)
            },
            onClickReward: (adId: any) => {
              console.log('Click on ad:', adId)
            },
            onAdsNotFound: () => {
              console.warn('No ads found to show')
            },
          })
          console.log('Tads controller initialized.')
          resolve()
        } else {
          console.warn('Tads not loaded yet.')
          setTimeout(tryInit, 100)
        }
      }

      tryInit()
    })
  }

  public showAd_Rewarded(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.adController) {
        console.warn('Tads controller not initialized.')
        reject('Tads controller not initialized.')
        return
      }

      this.adController
        .loadAd()
        .then(() => this.adController.showAd())
        .then(() => {
          console.log('Ad shown successfully')
          resolve()
        })
        .catch((err: any) => {
          console.error('Failed to show ad', err)
          reject(err)
        })
    })
  }
}

export default Tads
